import { createSelector } from 'reselect';
import _ from 'lodash';

/**
 * Resolves the passed fields for each object in the list as a selector
 * @param {array|object} list - Objects to resolve fields for
 * @param {...string} fields - Fields to resolve as selectors
 */
const createFieldSelector = (list, ...fields) => createSelector(
  _.map(list, (param) =>
    createSelector(
      fields.map((field) => param[field]),
      (...selected) => selected.reduce((result, field, index) => ({ ...result, [fields[index]]: field }), param)
    )
  ),
  (...selected) => selected
);

export default createFieldSelector;
